import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from "rxjs";
import {environment} from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) {
  }

  public post<T>(url: string, body: any, options: any = {}): Observable<T> {
    return this.http.post<T>(url, body, options).pipe(map((x: any) => x));
  }

  public get<T>(url: string, options: any = {}): Observable<T> {
    return this.http.get<T>(url, options).pipe(map((x: any) => x));
  }

}
